import React, { useRef, useEffect, useState } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Card from 'components/card'
import { scrollsize } from '../scrollheight'

const Stack = ({
  cards,
  title
}: {
  cards: contentElement[]
  title?: titleElement
}) => {
  const [content, setContent] = useState<(contentElement | titleElement)[]>()
  gsap.registerPlugin(ScrollTrigger)

  const ref = useRef(null)
  console.log(content)

  useEffect(() => {
    if (!cards) return
    const n: (contentElement | titleElement)[] = cards
    if (title)
      n.unshift({ ...title, Order: 0, Stapel: cards[0].Stapel, type: 'title' })
    setContent(n)
  }, [])

  if (!content) return null
  return (
    <div
      ref={ref}
      className='cardContainer'
      style={{ height: scrollsize * content.length + 'vh' }}
    >
      {content &&
        content
          .sort((a, b) => (a.Order || 0) - (b.Order || 0))
          .map((texts, index) => {
            return (
              <Card
                key={index.toString()}
                rotation={
                  Math.random() *
                  (window.innerWidth < 600 ? 0 : 2) *
                  (Math.round(Math.random()) ? 1 : -1)
                }
                id={index + 1}
                content={texts}
              />
            )
          })}
    </div>
  )
}
export default Stack
